import { ContentType } from '../../controller/services/comments-service-types';
export const getCommentContent = (content) => {
    try {
        return content ? JSON.parse(content) : undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export const toCommentText = (content) => ({
    content: JSON.stringify(content),
    contentType: ContentType.DRAFTJS,
});
//# sourceMappingURL=comment-content.js.map